import React from 'react'
import Tooltip from 'rc-tooltip'
import { StyledTooltip, TooltipHint, TooltipHintTitle, TooltipLabel } from './style'
import { FormattedMessage } from 'react-intl'

const TooltipComponent = ({ children, placement, kbaCriteria, trigger, overlay, link, hyper, textForLink, numberOfSites, zIndex, type='medium', ...rest }) => {
  const renderOverlay = overlay?.custom ?? (overlay?.infoTooltip ? (
    <TooltipHint data-test="tooltip" type={type}>
      <TooltipHintTitle type={type}>
        <FormattedMessage id={overlay.label} />
      </TooltipHintTitle>
      {overlay.infoTooltip && <FormattedMessage id={overlay.infoTooltip} values={{ mailTo: <a href={`mailto:${link}`}>{link}</a>, hyperLink: <a style={{textDecoration: textForLink ? 'none' : ''}} href={`${hyper}`} target="_blank" rel="noreferrer">{textForLink ? <b>{textForLink}</b> : hyper}</a> }}/>}
    </TooltipHint>
  ) : (
    <TooltipLabel>
      <FormattedMessage id={overlay.label} values={{assessmentNumber: <p>{`(${numberOfSites})`}</p> }} />
    </TooltipLabel>
  ))
  
  if (kbaCriteria) {
    return (
        <Tooltip zIndex={zIndex} placement={placement} trigger={trigger} overlay={renderOverlay} link={link} hyper={hyper} textForLink={textForLink} numberOfSites={numberOfSites} {...rest}>
          {children}
        </Tooltip>
    )
  }

  return (
    <StyledTooltip data-testid='test-tooltip'>
      <Tooltip zIndex={zIndex} placement={placement} trigger={trigger} overlay={renderOverlay} link={link} hyper={hyper} textForLink={textForLink} numberOfSites={numberOfSites} {...rest}>
        {children}
      </Tooltip>
    </StyledTooltip>
  )
}

export default TooltipComponent
